export default __webpack_public_path__ + "static/media/logo.c94d6f31.svg";